module.exports = __webpack_public_path__ + "static/media/4.e11bbee5.png";